(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {        	
        	this.viewFrom= 'forexConfigurations'
        })
        
        .controller('ForexConfigurationsController', ForexConfigurationsController);

        ForexConfigurationsController.$inject = ['$scope', '$state', 'workflowSharedService', 'ForexConfigurations', 'GlobalValues', 'EntityPermissions','ScreenLog','$rootScope','entityConstants','$timeout', 'AlertService', '$filter', ];

    function ForexConfigurationsController($scope, $state, workflowSharedService, ForexConfigurations, GlobalValues, EntityPermissions,ScreenLog,$rootScope,entityConstants,$timeout,AlertService,$filter) {
        
        var vm = this;
        
        vm.globalValues = GlobalValues;
        vm.screenLog = ScreenLog;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.MANAGE_Forex_Configurations;
        $scope.refresh=refresh;
        workflowSharedService.viewFrom = "forexConfigurations";
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        vm.clicked=false;
        vm.exportDataToFile = exportDataToFile;
        vm.orgid=vm.globalValues.getOrganisation();
        vm.forexConfigurationsfileName = "Forex_Configurations_";
        vm.fileName = vm.forexConfigurationsfileName;
        vm.reportFileTimestampFormat = 'DD_MMM_YYYY_HH_mm';
        vm.noOfDecimalsForRate = 3;
        
        vm.permitForexConfigurationsViewEntityAction = EntityPermissions.hasPermission('ManageForexConfigurations.VIEW')
        vm.permitForexConfigurationsEditEntityAction = EntityPermissions.hasPermission('ManageForexConfigurations.EDIT')
 
		console.log(vm.permitForexConfigurationsViewEntityAction);
		if(vm.permitForexConfigurationsViewEntityAction){
			loadAll();	
		}
        
		function loadAll(){
            if(vm.entityOwnerType=='Clearcorp'){
                ForexConfigurations.getAllForexConfigurations(function(result) {
                    vm.forexConfigurations = result;
                    vm.clicked=false;                    
                });	
            }else
			ForexConfigurations.getForexConfigurations({bankId: vm.globalValues.getOrganisation().id}, function(result) {
                vm.forexConfigurations = result;
                vm.clicked=false;                    
            });	
		}
		logScreenAccess();
        function logScreenAccess(){
           	ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
           }
        
        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
        function exportDataToFile(fileType){
            if(vm.bank == null  || vm.bank == undefined){
                vm.bankId=vm.globalValues.getOrganisation().id;
            }else{
                vm.bankId=vm.bank.id;
            }
			vm.fileName =  vm.forexConfigurationsfileName ;
				if(fileType == 'csv'){
					vm.mimeType = 'text/csv';
					vm.extension =  ".csv";  
					ForexConfigurations.exportForexConfigurationsCsv({bankId:vm.bankId}, processResponse );
				}
				else if(fileType == 'xls'){
					vm.mimeType = 'application/vnd.ms-excel';
					vm.extension = ".xls";  
					ForexConfigurations.exportForexConfigurationsExcel({bankId:vm.bankId},processResponse );
				}
		}

		function processResponse(result){        	  
			var fileData = null;
			fileData = result.data;
			var link = document.createElement("a");   
			var bytes = new Uint8Array( fileData );   // convert uint8 to binary array from arraybuffer
			vm.baseString =   vm.fileName + moment().format( vm.reportFileTimestampFormat ) +  vm.extension; 

			var blob = new Blob([bytes], {type: vm.mimeType});
			if(window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(blob, vm.baseString );
			}else{
				link.href =  window.URL.createObjectURL(blob);      
				link.download = vm.baseString;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}   
    }
})();
